import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Tarea } from '../../../shared/';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-header-description-task',
  templateUrl: './header-description-task.component.html',
  styleUrls: ['./header-description-task.component.scss']
})
export class HeaderDescriptionTaskComponent implements OnInit, OnDestroy {
  // Datos de la tarea
  @Input() task: Tarea;

  // define estilos personalizados para el contenedor del componente
  @Input() class: Array<string> | string = '';
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Notifica la actualizacion de informacion de la tarea
  @Output() updateTask: EventEmitter<Partial<Tarea>> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/header-description-task/header-description-task.component.ts